var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transaction-details-template', {
    attrs: {
      "header-icon": "shopping_discount"
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.displayTitle)
    },
    slot: "title"
  }), _c('div', {
    attrs: {
      "slot": "summary"
    },
    domProps: {
      "textContent": _vm._s(_vm.formattedAmount)
    },
    slot: "summary"
  }), _c('template', {
    slot: "content"
  }, [_vm.isSetupPayment ? _c('div', {
    class: _vm.$style.setup
  }, [_c('h4', {
    domProps: {
      "textContent": _vm._s(_vm.$t('transaction.content.setup.payment'))
    }
  }), _c('help-link', {
    directives: [{
      name: "color",
      rawName: "v-color",
      value: 'violet',
      expression: "'violet'"
    }],
    attrs: {
      "source": "https://help.capusta.space/bill/setup_payment"
    }
  })], 1) : _vm._e(), _c('sender-information', {
    attrs: {
      "sender": _vm.senderContent,
      "transaction": _vm.transaction
    }
  }), _vm.isShownDeclaration ? [_c('hr', {
    class: _vm.$style.delimiter
  }), _c('transaction-declaration', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.permission
    }
  })] : _vm._e()], 2), _vm.permission ? _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('link-button', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 20,
      expression: "20"
    }, {
      name: "p-b",
      rawName: "v-p-b",
      value: 20,
      expression: "20"
    }],
    attrs: {
      "href": "/report/generation/".concat(_vm.transaction.public_id),
      "variant": "transparent",
      "target": "_blank"
    }
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }, {
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "name": "file_file-text"
    }
  }), _c('span', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }],
    class: _vm.$style.footerLink,
    domProps: {
      "textContent": _vm._s(_vm.$t('common.report'))
    }
  })], 1)], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }